module.exports = __webpack_public_path__ + "24_cikm.jpg?a2fc9185b8279148b4225fa2803f880a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_cikm.jpg
// module id = 207
// module chunks = 0